module.exports = {
          srcSet: __webpack_public_path__ + "public/9dc76a522912ffd5403cffbbdf2e39d6-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/9dc76a522912ffd5403cffbbdf2e39d6-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/9dc76a522912ffd5403cffbbdf2e39d6-40.png",
          toString:function(){return __webpack_public_path__ + "public/9dc76a522912ffd5403cffbbdf2e39d6-40.png"},
          
          width: 40,
          height: 40
        }